import React from "react";

const Orders = props => {
  return <h1>Welcome to my orders!</h1>
}

export default Orders;